import { useMutationWithContext } from '../../../common/hooks/useMutationWithContext';
import {
    failedToastMessage,
    getIsUserProfileFromPathname,
    successToastMessage
} from '../../../common/utils/commonUtils';
import {
    saveResumeMutation,
    client,
    removeResumeMutation,
    mergeAnnotationMutation
} from '../../../common/components/person/person';
import useHistory from '../../../common/utils/useHistory';
import { Reference } from '../../../common/reference/reference';
import { useContext, useMemo } from 'react';
import { UserContext } from '../../../common/auth/UserContext';

export const useGetAnnotationForId = () => {
    const { routeParams, location } = useHistory();
    const { entityId } = routeParams;
    const { userProfile } = useContext(UserContext);
    const isUserProfile = getIsUserProfileFromPathname(location);
    const id = useMemo(() => (isUserProfile && !entityId ? userProfile.personReference.id : entityId), [entityId]);
    return id;
};

export const useSaveResume = () => {
    const id = useGetAnnotationForId();
    const [saveResume, { loading: saveResumeLoading }] = useMutationWithContext(saveResumeMutation, client);

    const onSaveResume = async (entityReference: Reference, piiConsent: boolean = true) => {
        return new Promise((resolve, reject) => {
            saveResume({
                variables: {
                    personId: id,
                    input: entityReference,
                    piiConsent
                }
            })
                .then((res: any) => {
                    if (res.data.saveResume.errors) {
                        failedToastMessage('resume.save.error');
                        reject(res.data.saveResume.errors);
                    } else {
                        successToastMessage('resume.save.success');
                        resolve(res);
                    }
                })
                .catch((err) => {
                    failedToastMessage('resume.save.error');
                    reject(err);
                });
        });
    };

    return { onSaveResume, saveResumeLoading };
};

export const useMergeAnnotation = () => {
    const personId = useGetAnnotationForId();
    const [mergeAnnotation, { loading: isMergingAnnotation }] = useMutationWithContext(mergeAnnotationMutation, client);

    const onMergeAnnotation = async (annotationId) => {
        return mergeAnnotation({
            variables: {
                personId,
                annotationId
            }
        })
            .then((res: any) => {
                res.data.mergeAnnotation.errors
                    ? failedToastMessage('merge.annotation.error')
                    : successToastMessage('merge.annotation.success');
            })
            .catch((err) => console.warn(err));
    };

    return { onMergeAnnotation, isMergingAnnotation };
};

export const useRemoveResume = () => {
    const id = useGetAnnotationForId();
    const [removeResume, { loading: removingResume }] = useMutationWithContext(removeResumeMutation, client);

    const onDeleteResume = async () => {
        return new Promise((resolve, reject) => {
            removeResume({
                variables: {
                    personId: id
                }
            })
                .then((res: any) => {
                    if (res.data.removeResume.errors) {
                        failedToastMessage('resume.delete.error');
                        reject(res.data.removeResume.errors);
                    } else {
                        successToastMessage('resume.delete.success');
                        resolve(res);
                    }
                })
                .catch((err) => {
                    failedToastMessage('resume.delete.error');
                    reject(err);
                });
        });
    };

    return { onDeleteResume, removingResume };
};
